var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCampaignPlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 491,
    height: 378,
    viewBox: "0 0 491 378",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 491,
    height: 378,
    fill: "#F7F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3705 311.557C74.8957 314.145 86.1205 329.73 104.115 323.082C121.852 316.582 133.795 294.35 142.398 278.758C152.316 260.688 160.518 241.718 172.227 224.915C180.899 212.48 196.657 199.561 213.119 204.661C252.863 217.069 270.687 266.013 298.331 223.706C355.645 64.7689 413.041 104.353 425.901 125.167C453.1 169.191 457.306 287.236 462.896 420.731L-43.6916 516.298C-21.0221 463.05 -1.06899 409.972 22.1167 356.908C27.0745 345.518 31.2338 332.562 38.3696 322.458C45.2859 312.687 51.8303 310.488 58.3705 311.557Z",
    fill: "#4376F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.431 153L106.88 237.113L119.136 282.855C163.167 285.344 217.586 288.422 269.501 291.349L232.431 153ZM77.5697 244.774L89.9105 290.83L107.658 286.075L95.3175 240.019L77.5697 244.774Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9105 290.83L77.5697 244.774L95.3175 240.019L107.658 286.075L89.9105 290.83Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.431 153L106.88 237.113L119.136 282.855C163.167 285.344 217.586 288.422 269.501 291.349L232.431 153ZM77.5697 244.774L89.9105 290.83L107.658 286.075L95.3175 240.019L77.5697 244.774Z",
    stroke: "#010237",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9105 290.83L77.5697 244.774L95.3175 240.019L107.658 286.075L89.9105 290.83Z",
    stroke: "#010237",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329 248C348.882 248 365 231.435 365 211C365 190.565 348.882 174 329 174C309.118 174 293 190.565 293 211C293 231.435 309.118 248 329 248Z",
    fill: "white",
    stroke: "#010237",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.238 202.122L304.654 202.122",
    stroke: "#010237",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.709 222.048L270 222.048",
    stroke: "#010237",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.814 43H346V142.741H167L181.814 127.349V43Z",
    fill: "white",
    stroke: "#010237",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.309 102.667L271.194 102.667",
    stroke: "#010237",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.309 82.1836L310.378 82.1836",
    stroke: "#010237",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 115.5,
    cy: 152.5,
    r: 26.5,
    fill: "#4376F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 491,
    height: 378,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignPlaceholder);
export default __webpack_public_path__ + "static/media/campaign_placeholder.296e9daef847eb435435138a0873255a.svg";
export { ForwardRef as ReactComponent };